import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserTokenCreateResponse } from '@zerops/zerops/core/user-token-base';
import { ServiceStack } from '@zerops/models/service-stack';
import { UserData } from '@zerops/models/user-data';

@Injectable({ providedIn: 'root' })
export class Z3HandoverApi {
  #httpClient = inject(HttpClient);

  /**
   * Mints a personal access token for a client. The secret is in this response
   * and nowhere else — the list endpoint returns names and ids only — so it is
   * handed straight to the redirect and never stored here.
   */
  create$(name: string): Observable<UserTokenCreateResponse> {
    return this.#httpClient.post<UserTokenCreateResponse>('/api/user-token', { name });
  }

  /**
   * The workspace the CLI named, read fresh rather than from the store: it may
   * sit in an organization other than the one this session is browsing, and
   * the consent screen must name it before any key moves.
   */
  serviceStack$(id: string): Observable<ServiceStack> {
    return this.#httpClient.get<ServiceStack>(`/api/service-stack/${id}`);
  }

  /**
   * Every env of the service, ids included. The service-stack read above lists
   * only the non-sensitive envs; a sensitive env such as a workspace's
   * `ZBOX_WORKSPACE_API_KEY` is present here and nowhere else, and its id is
   * what the reveal takes.
   */
  serviceStackEnvs$(id: string): Observable<{ items: UserData[]; }> {
    return this.#httpClient.get<{ items: UserData[]; }>(`/api/service-stack/${id}/env`);
  }
}
